import {
    Component,
    Input,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ButtonComponent } from "~app/common/components/button/button.component";
import { IconComponent } from "~app/common/components/icon/icon.component";
import { ListColumnDirective } from "~app/common/components/list/list-column.directive";
import { ListComponent } from "~app/common/components/list/list.component";
import { ConfirmDialogResponse } from "~app/common/models/constants";
import { PlaneraService } from "../../services/planera.service";
import { AvlaggVagInfoDto } from "./avlaggVaginfoModels";

@Component({
    selector: "rask-avlagg-vaginfo",
    templateUrl: "./avlagg-vaginfo.component.html",
    styleUrl: "./avlagg-vaginfo.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ListComponent,
        ListColumnDirective,
        IconComponent,
        ButtonComponent
    ]
})
export class AvlaggVaginfoComponent implements OnInit {
    arbetsorderId: any;
    avlaggInfo: AvlaggVagInfoDto[];

    private readonly planeraService = inject(PlaneraService);
    private readonly modal = inject(NgbActiveModal);

    @Input() set data(value: any) {
        this.arbetsorderId = value.arbetsorderId;
    }

    ngOnInit(): void {
        this.planeraService.getAvlaggVagInfo(this.arbetsorderId).subscribe(x => {
            this.avlaggInfo = x;
        });
    }
    dismiss() {
        this.modal.close(ConfirmDialogResponse.cancel);
    }
}
